import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type GetServiceUserInvitesResponse = {
  __typename?: 'GetServiceUserInvitesResponse';
  invites: Array<Invite>;
};

export type Invite = {
  __typename?: 'Invite';
  createdAt: Scalars['DateTime']['output'];
  givenName?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  referralSession: ReferralSession;
  reviewEnabled?: Maybe<Scalars['Boolean']['output']>;
  status: ReferralInviteStatus;
  surveyResponse?: Maybe<SurveyResponse>;
  surveyResponseId?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  getServiceUserInvites: GetServiceUserInvitesResponse;
};

export type Referral = {
  __typename?: 'Referral';
  contact?: Maybe<Scalars['String']['output']>;
  service: Service;
  status: ReferralStatus;
};

export enum ReferralInviteStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Pending = 'pending'
}

export type ReferralSession = {
  __typename?: 'ReferralSession';
  referral: Referral;
  status: ReferralSessionStatus;
};

export enum ReferralSessionStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Pending = 'pending'
}

export enum ReferralStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Pending = 'pending'
}

export type Service = {
  __typename?: 'Service';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  answers?: Maybe<Scalars['JSON']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GetServiceUserInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceUserInvitesQuery = { __typename?: 'Query', getServiceUserInvites: { __typename?: 'GetServiceUserInvitesResponse', invites: Array<{ __typename?: 'Invite', createdAt: any, givenName?: string | null, publicId: string, surveyResponseId?: string | null, reviewEnabled?: boolean | null, status: ReferralInviteStatus, surveyResponse?: { __typename?: 'SurveyResponse', answers?: any | null, completedAt?: any | null } | null, referralSession: { __typename?: 'ReferralSession', status: ReferralSessionStatus, referral: { __typename?: 'Referral', status: ReferralStatus, contact?: string | null, service: { __typename?: 'Service', description: string, code: string } } } }> } };


export const GetServiceUserInvitesDocument = gql`
    query GetServiceUserInvites {
  getServiceUserInvites {
    invites {
      createdAt
      givenName
      publicId
      surveyResponseId
      surveyResponse {
        answers
        completedAt
      }
      referralSession {
        status
        referral {
          service {
            description
            code
          }
          status
          contact
        }
      }
      reviewEnabled
      status
    }
  }
}
    `;

export function useGetServiceUserInvitesQuery(options?: Omit<Urql.UseQueryArgs<GetServiceUserInvitesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetServiceUserInvitesQuery, GetServiceUserInvitesQueryVariables>({ query: GetServiceUserInvitesDocument, ...options });
};